module.exports = __webpack_public_path__ + "img/qu1.31d7c1e9.png";